// extracted by mini-css-extract-plugin
module.exports = {"wrap":"hl-z","subtitle":"il-z","contentWrap":"jl-z","imgWrap":"kl-z","heading":"ll-z","copy":"ml-z"};